exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.reference-avatar[data-v-f2820042] {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  width: 2.25rem;\n  height: 2.25rem;\n  border-radius: 50%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  color: #fff;\n  font-family: Arial, Helvetica, sans-serif;\n  font-weight: 550;\n  font-size: 0.72rem;\n  line-height: 1;\n  text-align: center;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-f2820042","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/ReservationPayIn/ReferenceAvatar.vue
// module id = 1975
// module chunks = 0